import { api } from "api/api";
import { AxiosError } from "axios";
import Usuario from "model/administracao/cadastro/Usuario";
import CategoriaDocumento from "model/documentos/CategoriaDocumento";
import { DocumentoPasta } from "model/documentos/DocumentoPasta";
import { DataTableFilterMeta } from "primereact/datatable";
import { getFilters } from "utils/filterUtils";
import DocumentoVersao from "model/documentos/DocumentoVersao";
import AdicionarRevisao from "model/documentos/fluxo/AdicionarRevisao";
import FiltrosListaMestra from "model/documentos/FiltrosListaMestra";
import { errorDecoder } from "utils/errorUtil";

export default class DocumentoPastaService {

    criar(documentoPasta: DocumentoPasta): Promise<DocumentoPasta> {
        return new Promise((resolve, reject) => {
            api.post(`/documentoPasta`, documentoPasta)
                .then(response => resolve(response.data))
                .catch((err) => reject(err.response));
        });
    }
    atualizar(documentoPasta: DocumentoPasta): Promise<DocumentoPasta> {
        return new Promise((resolve, reject) => {
            api.put(`/documentoPasta`, documentoPasta)
                .then(response => resolve(response.data))
                .catch((err) => reject(err.response));
        });
    }
    moverDocumento(idDocumento: number, idPasta: number): Promise<void> {
        return new Promise((resolve, reject) => {
            api.put(`/documentoPasta/moverDocumento/${idDocumento}/${idPasta}`)
                .then(() => resolve())
                .catch((err) => reject(err.response));
        });
    }
    moverPasta(idPasta: number, idPastaMae: number): Promise<void> {
        return new Promise((resolve, reject) => {
            api.put(`/documentoPasta/moverPasta/${idPasta}/${idPastaMae}`)
                .then(() => resolve())
                .catch((err) => reject(err.response));
        });
    }
    adicionarRevisao(dados: AdicionarRevisao): Promise<DocumentoVersao> {
        return new Promise((resolve, reject) => {
            api.post(`/documentoPasta/adicionarRevisao`, dados)
                .then(response => resolve(response.data))
                .catch((err) => reject(err.response));
        });
    }
    consultarRoot(): Promise<DocumentoPasta> {
        return new Promise((resolve, reject) => {
            api.get(`/documentoPasta/consultar`)
                .then(response => resolve(response.data))
                .catch((err) => reject(err.response));
        });
    }
    consultar(id: number): Promise<DocumentoPasta> {
        return new Promise((resolve, reject) => {
            api.get(`/documentoPasta/consultar?id=${id}`)
                .then(response => resolve(response.data))
                .catch((err) => reject(err.response));
        });
    }
    versaoPublicada(idDocumento: number): Promise<DocumentoVersao> {
        return new Promise((resolve, reject) => {
            api.get(`/documentoPasta/documento/versaoPublicada/${idDocumento}`)
                .then(response => resolve(response.data))
                .catch((err) => reject(err.response));
        });
    }
    downloadZip(id: number | undefined): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = `/documentoPasta/downloadZip`;
            if (id) {
                url += `?id=${id}`;
            }
            api.get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err) => reject(err.response));
        });
    }
    buscarTodas(): Promise<DocumentoPasta[]> {
        return new Promise((resolve, reject) => {
            api.get(`/documentoPasta/all`)
                .then(response => resolve(response.data))
                .catch((err) => reject(err.response));
        });
    }
    remover(id: number): Promise<void> {
        return new Promise((resolve, reject) => {
            api.delete(`/documentoPasta/${id}`)
                .then(() => resolve())
                .catch((err) => reject(err.response));
        });
    }
    excluirPermanentemente(id: number): Promise<void> {
        return new Promise((resolve, reject) => {
            api.delete(`/documentoPasta/excluirPermanentemente/${id}`)
                .then(() => resolve())
                .catch((err) => reject(err.response));
        });
    }

    recuperarPasta(id: number): Promise<void> {
        return new Promise((resolve, reject) => {
            api.put(`/documentoPasta/recuperarPasta/${id}`)
                .then(() => resolve())
                .catch((err) => reject(err.response));
        });
    }

    removerDocumento(id: number): Promise<void> {
        return new Promise((resolve, reject) => {
            api.delete(`/documentoPasta/removerDocumento/${id}`)
                .then(() => resolve())
                .catch((err) => reject(err.response));
        });
    }

    excluirDocumentoPermanentemente(id: number): Promise<void> {
        return new Promise((resolve, reject) => {
            api.delete(`/documentoPasta/excluirDocumentoPermanentemente/${id}`)
                .then(() => resolve())
                .catch((err) => reject(err.response));
        });
    }

    recuperarDocumento(id: number): Promise<void> {
        return new Promise((resolve, reject) => {
            api.put(`/documentoPasta/recuperarDocumento/${id}`)
                .then(() => resolve())
                .catch((err) => reject(err.response));
        });
    }

    consultarRootExcluido(): Promise<DocumentoPasta> {
        return new Promise((resolve, reject) => {
            api.get(`/documentoPasta/consultar/excluido`)
                .then(response => resolve(response.data))
                .catch((err) => reject(err.response));
        });
    }
    consultarPastaExcluida(id : number): Promise<DocumentoPasta> {
        return new Promise((resolve, reject) => {
            api.get(`/documentoPasta/consultar/excluido?id=${id}`)
                .then(response => resolve(response.data))
                .catch((err) => reject(err.response));
        });
    }

    pastaTemMaeValida(id: number): Promise<Boolean> {
        return new Promise((resolve, reject) => {
            api.get(`/documentoPasta/pastaTemMaeValida/${id}`)
                .then(response => resolve(response.data))
                .catch((err) => reject(err.response));
        });
    }

    documentoTemMaeValida(id: number): Promise<Boolean> {
        return new Promise((resolve, reject) => {
            api.get(`/documentoPasta/documentoTemMaeValida/${id}`)
                .then(response => resolve(response.data))
                .catch((err) => reject(err.response));
        });
    }

    getRelatorioListaMestra(listaMestraFilter: any) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/documentoPasta/report/listaMestra`;
            api
                .post(url, listaMestraFilter, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getRelatorioDocumentosDistribuidos(filtros: FiltrosListaMestra) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/documentoPasta/report/documentosDistribuicao`;
            url += `?filters=${encodeURI(JSON.stringify(filtros))}`;
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getCopiaNaoControlada = (id : number): Promise<Blob> => {
        return new Promise<Blob>((resolve, reject): void => {
            let url = `/documentoPasta/copiaNaoControlada/${id}`;
            api
                .get(url, { responseType: 'blob' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => {
                    reject(err.response)
                });
        });
    }

    categorias() {
        return new Promise<CategoriaDocumento[]>((resolve, reject): void => {
            api
                .get(`/documento/categorias`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    usuarios() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/documento/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    statuses() {
        return [
            { label: 'Em Elaboração', value: 'EE' },
            { label: 'Em Revisão', value: 'ER' },
            { label: 'Aguardando Aprovação', value: 'AA' },
            { label: 'Aguardando Publicação', value: 'AP' },
            { label: 'Publicado', value: 'P' },
            { label: 'Obsoleto', value: 'O' },
            { label: 'Removido', value: 'R' },
            { label: 'Apagado', value: 'A' },
        ]
    }

    internoExterno() {
        return [
            { label: 'Externo', value: 'E' },
            { label: 'Interno', value: 'I' },
        ]
    }
}
